import React, { useState, useEffect } from "react";
import { producaov2 } from "../../../services/apis";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { Menu, Icon } from "semantic-ui-react";
import { Container, Title, SemanticTable } from "./styled";
import { isAuthAdmin } from "../../../services/auth";

function PessoaWhiteBelt() {
  const [pessoas, setPessoas] = useState([]);

  useEffect(() => {
    loadAuth();
    loadPessoasCursoPago();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadPessoasCursoPago = async (page = 1) => {
    const response = await producaov2.get(`admin/pessoa/curso/whiteBelt`);
    const { data } = response;
    let logs = {
      local: "PessoaWhiteBelt",
      texto: `listou as pessoas com o curso white belt`,
    };
    await producaov2.post("system_logs", { acao: JSON.stringify(logs) });
    setPessoas(data);
  };

  return (
    <>
      <AdminMenu />

      <Container>
        <Title>Pessoas com o curso White Belt</Title>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Pessoa</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Telefone</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>
                Status do curso
              </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {pessoas.map((pessoa) => (
              <SemanticTable.Row>
                <SemanticTable.Cell>
                  {pessoa.pessoa !== null ? pessoa.pessoa.nome : null}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {pessoa.pessoa !== null ? pessoa.pessoa.email : null}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {pessoa.pessoa !== null ? pessoa.pessoa.celular : null}
                </SemanticTable.Cell>
                <SemanticTable.Cell>{pessoa.status}</SemanticTable.Cell>
              </SemanticTable.Row>
            ))}
          </SemanticTable.Body>
        </SemanticTable>
      </Container>
    </>
  );
}

export default PessoaWhiteBelt;
